import { 
  Heading, 
  Text, 
  VStack, 
  HStack, 
  Box, 
  Icon,
  Badge,
  Divider,
  Flex
} from "@chakra-ui/react";
import React from "react";
import NavWrapper from "./NavWrapper";
import { FiLayers, FiList } from "react-icons/fi";

export default function SimpleVsComplexPaneTutorial() {
  return (
    <NavWrapper
      previousEnabled={true}
      isFinalStep={false}
      nextDisabled={false}
    >
      <VStack w="100%" textAlign={"left"} alignItems={"flex-start"} spacing={4} px={4}>
        <Heading
          as="h2"
          fontSize="20px"
          fontWeight={700}
          textAlign={"left"}
          w="100%"
          color="var(--accent)"
        >
          📊 Simple vs Advanced Views
        </Heading>
        
        <Text fontSize="14px" color="gray.300">
          WealthBee offers two viewing modes for your positions. Choose the one that fits your needs:
        </Text>

        {/* Simple View Card */}
        <Box
          w="100%"
          bg="rgba(66, 153, 225, 0.1)"
          borderRadius="12px"
          p={4}
          border="2px solid"
          borderColor="blue.400"
          transition="all 0.2s"
          _hover={{ transform: "translateY(-2px)", boxShadow: "lg" }}
        >
          <HStack spacing={3} mb={3}>
            <Flex
              bg="blue.500"
              borderRadius="full"
              p={2}
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={FiList} boxSize={5} color="white" />
            </Flex>
            <VStack align="flex-start" spacing={0}>
              <Heading as="h3" fontSize="16px" fontWeight={600}>
                Simple View
              </Heading>
              <Badge colorScheme="blue" fontSize="10px">
                Perfect for clarity
              </Badge>
            </VStack>
          </HStack>
          <Text fontSize="13px" lineHeight="1.6">
            • <strong>Flat list view</strong> of all your trades<br />
            • <strong>Easy to scan</strong> - no nested groups<br />
            • <strong>Simplified columns</strong> showing key metrics<br />
            • <strong>Best for:</strong> Quick overviews and simple portfolios
          </Text>
        </Box>

        {/* Advanced View Card */}
        <Box
          w="100%"
          bg="rgba(128, 90, 213, 0.1)"
          borderRadius="12px"
          p={4}
          border="2px solid"
          borderColor="purple.400"
          transition="all 0.2s"
          _hover={{ transform: "translateY(-2px)", boxShadow: "lg" }}
        >
          <HStack spacing={3} mb={3}>
            <Flex
              bg="purple.500"
              borderRadius="full"
              p={2}
              alignItems="center"
              justifyContent="center"
            >
              <Icon as={FiLayers} boxSize={5} color="white" />
            </Flex>
            <VStack align="flex-start" spacing={0}>
              <Heading as="h3" fontSize="16px" fontWeight={600}>
                Advanced View
              </Heading>
              <Badge colorScheme="purple" fontSize="10px">
                For power users
              </Badge>
            </VStack>
          </HStack>
          <Text fontSize="13px" lineHeight="1.6">
            • <strong>Hierarchical grouping</strong> by books and strategies<br />
            • <strong>Detailed analytics</strong> with all available columns<br />
            • <strong>Drag & drop</strong> to organize positions<br />
            • <strong>Best for:</strong> Complex portfolios and detailed analysis
          </Text>
        </Box>

        <Divider borderColor="gray.600" />

        {/* Switch Location */}
        <Box
          w="100%"
          bg="rgba(255, 255, 255, 0.05)"
          borderRadius="8px"
          p={3}
        >
          <HStack spacing={2} mb={2}>
            <Text fontSize="13px" fontWeight={600}>
              💡 How to Switch:
            </Text>
          </HStack>
          <Text fontSize="12px" color="gray.400">
            Find the toggle switch in the sidebar (left menu). Look for the{" "}
            <Badge colorScheme="green" fontSize="10px" mx={1}>Simple</Badge>
            or
            <Badge colorScheme="purple" fontSize="10px" mx={1}>Advanced</Badge>
            {" "}indicator. Click it to switch between views instantly!
          </Text>
        </Box>
      </VStack>
    </NavWrapper>
  );
}
